


export type FormDefinitionEmailType = 'Custom';

export const FormDefinitionEmailType = {
    Custom: 'Custom' as FormDefinitionEmailType
};

